import style from "../styles/style.module.css";
import logo from "../images/logo.svg";
import statusIcon from "../images/status.svg";
import { useState } from "react";
import moment from "moment-timezone";
import { useWhichDashboard } from "../hooks/useWhichDashboard";

function MainLayout({ children, name, driver, trackings, company, load }) {
  const [checker, setChecker] = useState(false);
  const [rotate, setRotate] = useState(false);
  const last_tracking = trackings[trackings.length - 1];
  const dashData = useWhichDashboard();

  return (
    <div className={style.container}>
      <div className={style.left_sidebar}>
        <div className={style.block}>
          <div className={style.header}>
            <div className={style.logo}>
              <img className={style.logo_image} src={dashData.logo || logo} height={100} alt="logo" />
            </div>
          </div>

          <div className={style.company}>
            <div className={style.cmp_name_icon}>
              <img src={statusIcon} alt="status" />
              <span className={style.comapany_text}>{name}</span>
              <div
                className={style.refreshIco}
                style={{ transform: rotate ? "rotate(360deg)" : "", transition: "2s" }}
                onClick={() => {
                  setRotate(!rotate);
                  load();
                }}
              ></div>
            </div>

            <div className={style.driver_data}>
              <div className={style.left}>
                <DriverInfo driver={driver} last_tracking={last_tracking} company={company} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Header */}
      <div className={style.headerMobile}>
        <div className={style.logo}>
          <img height={60} className={style.logo_image} src={logo} alt="logo" />
        </div>
      </div>

      {/* Footer */}
      <div className={style.footter} style={{ height: checker && "auto", bottom: 0 }}>
        <div className={style.company}>
          <div className={style.cmp_name_icon}>
            <img src={statusIcon} alt="status" />
            <span className={style.comapany_text}>{name}</span>
            <div
              className={style.refreshIco}
              style={{ transform: rotate ? "rotate(360deg)" : "", transition: "2s" }}
              onClick={() => {
                setRotate(!rotate);
                load();
              }}
            ></div>
          </div>
          <div className={style.driver_data}>
            <div className={style.left}>
              <DriverInfo driver={driver} last_tracking={last_tracking} company={company} showPhone />
            </div>
          </div>
        </div>
      </div>

      <div
        className={style.downIco}
        style={{ transform: checker && "rotate(0)" }}
        onClick={() => setChecker(!checker)}
      ></div>

      <div className={style.right_sidebar}>{children}</div>
    </div>
  );
}

function DriverInfo({ driver, last_tracking, company, showPhone = false }) {
  return (
    <>
      <div className={style.info}>
        <div className={style.infoText}>Drivers:</div>
        <p style={{ marginLeft: "10px" }} className={style.infoData}>
          {driver.first_name + " " + driver.second_name}
        </p>
        {driver.codriver && (
          <p style={{ marginLeft: "10px" }} className={style.infoData}>
            {driver.codriver.first_name + " " + driver.codriver.second_name}
          </p>
        )}
      </div>
      {showPhone && (
        <div className={style.info}>
          <div className={style.infoText}>Phone</div>
          <p className={style.infoData}>{driver.phone}</p>
        </div>
      )}
      <div className={style.info}>
        <div className={style.infoText}>Truck number</div>
        <p className={style.infoData}>
          {driver?.status?.trailer ? driver.vehicle.truck_number : "N/A"}
        </p>
      </div>
      <div className={style.info}>
        <div className={style.infoText}>Trailer</div>
        <p className={style.infoData}>
          {driver?.status?.trailer || "no trailer"}
        </p>
      </div>
      <div className={style.info}>
        <div className={style.infoText}>Shipping Document</div>
        <p className={style.infoData}>
          {driver.status.document ? driver.status.document : "N/A"}
        </p>
      </div>
      <div className={style.info}>
        <div className={style.infoText}>Current location</div>
        <p className={style.infoData}>{last_tracking?.address}</p>
      </div>
      <div className={style.info}>
        <div className={style.infoText}>Time Zone</div>
        <p className={style.infoData}>{company.tz.value}</p>
      </div>
      <div className={style.info}>
        <div className={style.infoText}>Time</div>
        <p className={style.infoData}>
          {moment(last_tracking?.checked_date).tz(company.tz.value).format("DD-MM-YYYY hh:mm:ss z")}
        </p>
      </div>
    </>
  );
}

export default MainLayout;
